/* Solyn header — scroll shadow + fade on scroll-down */
(function () {
  function init() {
    var header = document.querySelector('.header-wrapper');
    var section = document.querySelector('.shopify-section-header');
    if (!header) return;
    var ticking = false;
    var lastY = window.scrollY;
    var hideThreshold = 8;     // require >8px down to hide
    var topZone = 120;         // always show within this many px from top
    function update() {
      ticking = false;
      var y = window.scrollY;
      var scrolled = y > 4;
      header.classList.toggle('is-scrolled', scrolled);
      if (section) section.classList.toggle('is-scrolled', scrolled);
      document.body.classList.toggle('is-scrolled', scrolled);
      var delta = y - lastY;
      // Always show in the top zone (above-the-fold area)
      if (y <= topZone) {
        header.classList.remove('is-hiding');
      } else if (delta > hideThreshold) {
        // Scrolling down past the top zone — hide
        header.classList.add('is-hiding');
      } else if (delta < 0) {
        // Any upward movement — show immediately
        header.classList.remove('is-hiding');
      }
      lastY = y;
    }
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
